import { optionsToStrategy } from '@/common/utils/optionsToStrategy'

export const options = [
  { label: 'Padrão', value: 'default' },
  { label: 'Consumo', value: 'consumption' },
  { label: 'Imposto de Renda', value: 'income_tax' },
]

export const strategy = optionsToStrategy(options)
